// extracted by mini-css-extract-plugin
module.exports = {"container":"Web_container__2S2rb","layout":"Web_layout__2JpnE"};